// extracted by mini-css-extract-plugin
export default {"adminPromtionOnly":"promotion_adminPromtionOnly__Ivxfu","SwitchText":"promotion_SwitchText__F+paZ","icon":"promotion_icon__nmVF1","iconDanger":"promotion_iconDanger__xe72A"};